import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/chevron-up.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M11.3692 8.22462C11.762 7.90427 12.341 7.92686 12.7071 8.29298L18.7071 14.293L18.7754 14.3692C19.0958 14.7619 19.0732 15.3409 18.7071 15.707C18.341 16.0732 17.762 16.0958 17.3692 15.7754L17.293 15.707L12 10.4141L6.70708 15.707C6.31655 16.0976 5.68354 16.0976 5.29302 15.707C4.90249 15.3165 4.90249 14.6835 5.29302 14.293L11.293 8.29298L11.3692 8.22462Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ChevronUpIcon };
